import API_KEY from '../api/index';

export const getSessionId = (userId, org) => {
  return API_KEY.URL.post(
    `${API_KEY.path.session}`,
    {},
    {
      params: {
        visitor: userId,
        identifier: org,
      },
    }
  );
};

export const sendEvent = (sessionId, eventName, event) => {
  return API_KEY.URL.post(`${API_KEY.path.getdetails}`, event, {
    params: {
      session: sessionId,
      name: eventName,
    },
  });
};
